import React from "react";
import { Grid, GridItem, ColumnSpan } from "../grid";
import cn from "clsx";
import { Heading } from "../typography/heading";
import Teaser, { TeaserProps } from "../teaser/teaser";

export type TeaserCollectionProps = {
  variant?: "primary" | "secondary";
  title?: string;
  link?: { url: string; title?: string };
  imageStyle?: TeaserProps["imageStyle"];
  imageSize?: "small" | "large";
  columns?: 2 | 3 | 4;
  items: TeaserProps[];
  showLead?: boolean;
} & React.ButtonHTMLAttributes<HTMLDivElement>;

const TeaserCollection = React.forwardRef<
  HTMLDivElement,
  TeaserCollectionProps
>(
  (
    {
      className,
      variant,
      title,
      link,
      imageSize,
      imageStyle = "square",
      columns = 3,
      items,
      showLead,
    },
    ref
  ) => {
    const contentTypes: string[] = items.map((item) => item.contentType);
    const isContentTypeHomogeneous = contentTypes.every(
      (val, i, arr) => val === arr[0]
    );

    return (
      <div className={cn("in-teaser-collection", className)}>
        {title && (
          <Heading as="h2" className="in-teaser-collection__title">
            {title}
          </Heading>
        )}
        <Grid className={cn("in-teaser-collection-grid")}>
          {(items || []).map((item, index) => (
            <GridItem
              key={index}
              spanLarge={
                (12 / columns) as ColumnSpan
              }
              spanMedium={imageStyle === "portrait" ? 3:4}
              spanSmall={imageStyle === "portrait" ? 2:4}
              className={cn("in-teaser-collection-grid__item")}
            >
              <Teaser
                variant={variant}
                title={item.title}
                image={{ src: item.image?.src, alt: item.image?.alt }}
                imageStyle={imageStyle}
                imageSize={imageSize}
                tags={item.tags}
                columns={columns}
                lead={showLead ? item.lead : undefined}
                contentType={
                  isContentTypeHomogeneous ? undefined : item.contentType
                }
                url={item.url}
              />
            </GridItem>
          ))}
        </Grid>
        {link && (
          <span className="in-teaser-collection__link">
            <a href={link.url} aria-label={link.title? "" : `Se alle - ${title}`}>{link.title || "Se alle"}</a>
          </span>
        )}
      </div>
    );
  }
);

export default TeaserCollection;
export { TeaserCollection };
